var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useContext, useMemo } from 'react';
import classnames from 'classnames';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { CalendarIcon } from '@heroicons/react/20/solid';
import { LocaleContext } from 'providers/locale-settings-context';
import InputWithLeadingIcon from './forms/InputWithLeadingIcon';
const monthMask = [/[0-1]/, /[0-9]/];
const dayMask = [/[0-3]/, /[0-9]/];
const yearMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
const DATE_SEPARATOR = '/';
const dateMask = [
    ...monthMask,
    DATE_SEPARATOR,
    ...dayMask,
    DATE_SEPARATOR,
    ...yearMask,
];
const internationalDateMask = [
    ...dayMask,
    DATE_SEPARATOR,
    ...monthMask,
    DATE_SEPARATOR,
    ...yearMask,
];
export default function CustomDateInput(_a) {
    var _b;
    var { value, onChange, alwaysShowMask, disabled, className, dataTestId } = _a, props = __rest(_a, ["value", "onChange", "alwaysShowMask", "disabled", "className", "dataTestId"]);
    const localeContext = useContext(LocaleContext);
    const dateFormat = (_b = localeContext === null || localeContext === void 0 ? void 0 : localeContext.localeData) === null || _b === void 0 ? void 0 : _b.dateFormat;
    function getMask() {
        if (dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.startsWith('DD')) {
            return internationalDateMask;
        }
        return dateMask;
    }
    const [mask, setMask] = useState(getMask());
    useEffect(() => {
        if (!dateFormat.startsWith('DD')) {
            // Conditional mask for the 2nd digit base on the first digit
            if ((value || '').startsWith('1')) {
                setMask([dateMask[0], /[0-2]/, ...dateMask.slice(2)]);
            }
            else {
                setMask([...dateMask]);
            }
        }
    }, [value]);
    function handleChange(e) {
        onChange(e);
    }
    return ((React.createElement(InputMask, Object.assign({ mask: mask, value: value, alwaysShowMask: alwaysShowMask, disabled: disabled, "data-testid": dataTestId }, props, { onChange: handleChange }),
        React.createElement(InputWithLeadingIcon, { dataTestId: "InputWithLeadingIcon-b550aaa0", value: value, className: className, passEventOnChange: true },
            React.createElement(CalendarIcon, { className: "w-4 h-4" })))));
}
CustomDateInput.props = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    alwaysShowMask: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
};
CustomDateInput.defaultProps = {
    alwaysShowMask: true,
    disabled: false,
};
